import { useEnvironment } from '@wix/yoshi-flow-editor';
import { sectionSettingsCssProperties } from '../Settings/useSettingsSections';
import { uninitializedVisibilitySettingsTrueValue } from '../settingsParams';
import stylesParams from '../stylesParams';
import { ISection, SectionTypes } from '../types';
import { useWidgetSections } from '../Widget/useWidgetSections';
import { useCachedStyles } from './useVisibilityCheck';

export function useSectionVisibilityCheck() {
  const { isCssPerBreakpoint } = useEnvironment();
  const { getStylesForAllBreakpoints } = useCachedStyles();
  const sections = useWidgetSections();

  const sectionShouldBeVisibleHandler = (
    keyInSectionSettings: keyof ISection,
    sectionType: SectionTypes,
    styleParamCssProperty: keyof typeof stylesParams,
  ) => {
    const section = sections.find(
      (currSection) => currSection.type === sectionType,
    );

    const settingsValue = section![keyInSectionSettings];

    return isCssPerBreakpoint
      ? getStylesForAllBreakpoints().some(
        ({ booleans }) => booleans[styleParamCssProperty],
      )
      : typeof settingsValue === 'boolean'
        ? settingsValue
        : settingsValue === uninitializedVisibilitySettingsTrueValue as any;
  };

  return {
    shouldSectionBeVisible(sectionType: SectionTypes) {
      return sectionShouldBeVisibleHandler(
        'visible',
        sectionType,
        sectionSettingsCssProperties[sectionType].isVisible,
      );
    },
    shouldSectionBookButtonBeVisible(sectionType: SectionTypes) {
      return sectionShouldBeVisibleHandler(
        'bookButton',
        sectionType,
        sectionSettingsCssProperties[sectionType].isBookButtonVisible,
      );
    },
  };
}
